import * as components from './components'

export default [
  {
    path: '/connectorManagement',
    component: components.ConnectorList,
    name: 'connectorList',
    props: true
  },
  {
    path: '/connectorManagement/create',
    component: components.ConnectorCreate,
    name: 'connectorCreate',
    props: true
  },
  {
    path: '/connectorManagement/:uuid/edit',
    component: components.ConnectorCreate,
    name: 'connectorEdit',
    props: true
  }
]



// WEBPACK FOOTER //
// ./src/app/connector/routes.js